import useListApi from "../../../hooks/useListApi";
import URLS from "../../../API/Axios/URLS";
import NotificationItem, {NotificationItemAnimation} from "./component/notification-item";
import React from "react";
import Paginator from "../../../components/Table/Paginator";
import {IoIosSad} from "react-icons/io";
import Filter from "../practice/component/Filter";
import NotificationTypes from "../../../utils/notification-types";

export default function NotificationPage({className, ...props}) {
    let [data, filter, loading, actions] = useListApi(URLS.getNotifications, {
        notification_type: "all",
        page_size: 10,
        search: ""
    }, () => {
        let focus_auto_section = document.getElementById("focus-auto-section")
        if (focus_auto_section) {
            focus_auto_section.scrollIntoView({behavior: "smooth"})
        }
    });
    return (
        <div id={"focus-auto-section"}
             className={`flex flex-col justify-center items-center pt-2 lg:pt-10 ${className}`}>



            <div className={"w-full lg:w-1/2 p-4 lg:p-5 lg:bg-white lg:shadow-sm lg:rounded-md"}>
                <div className={"flex flex-row justify-end mb-8"}>
                    <Filter
                        select={(e) => {
                            actions.updateFilter({notification_type: e?.filter})
                        }}
                        currentValue={filter?.notification_type}
                        title={"Filter"}
                        options={NotificationTypes}
                    />
                </div>

                {loading && <>
                    {
                        Array(filter?.page_size || 10).fill(0).map((_, index) => (
                            <NotificationItemAnimation key={index} className={"w-full"}/>
                        ))
                    }
                </>
                }

                {
                    !loading && data?.results?.map((item, index) => {
                        return <NotificationItem key={index} {...item}/>
                    })
                }
                {
                    !loading && data?.results?.length === 0 &&
                    <div className={"flex flex-col my-12 gap-2 items-center"}>
                        <IoIosSad className={"text-4xl"}/>


                        <p className={"font-bold text-xl"}>
                            Total {data?.count} results found
                        </p>
                    </div>
                }
            </div>
            {
                data?.totalPages ? <Paginator
                    className={"my-10"}
                    currentPage={data?.currentPage}
                    totalPages={data?.totalPages}
                    onNext={(e) => {
                        actions.loadNextPage()
                    }}
                    onPrev={(e) => actions.loadPrevPage()}
                    onPageNumberClick={(e) => {
                        actions.loadSpecificPage(e)
                    }}
                /> : <></>
            }

        </div>

    )
}